import { ComponentTypeWithRepresentation as ComponentTypeWithRepresentationType } from './types';
import { OptionContainer } from './atoms';
import { ComponentDecoratorAsTag } from '@ardoq/basic-components';

export const ComponentTypeWithRepresentation = ({
  name,
  representationData,
}: ComponentTypeWithRepresentationType) => {
  return (
    <OptionContainer>
      <ComponentDecoratorAsTag {...representationData} label={name} noMargin />
    </OptionContainer>
  );
};
